import React from 'react'
import { SvgIcon } from '../svg-icon'

const defaultProps = {
    width: 16,
    height: 16,
    viewBoxSize: 48
}

// {@link SvgIcon.propTypes} for info on accepted props

function CameraIcon(props) {
    return (
        <SvgIcon {...props}>
            <path
                d={`M24.074 21.307a4.823 4.823 0 0 0-4.818 4.818c0 2.657 2.16 4.818 4.818 4.818s4.818-2.16
                    4.818-4.818a4.824 4.824 0 0 0-4.818-4.818z`}
            />
            <path
                d={`M42.4 11.523h-1.364v-.504a3.65 3.65 0 0 0-3.65-3.652h-9.662a3.65 3.65 0 0 0-3.65
                    3.65v.505H5.746a3.65 3.65 0 0 0-3.65 3.65v21.904a3.65 3.65 0 0 0 3.65 3.65H42.4a3.65 3.65 0 0 0
                    3.65-3.65V15.174a3.65 3.65 0 0 0-3.65-3.65zM8.87 21.307a2.95 2.95 0 1 1 .002-5.9 2.95 2.95 0 0 1 0
                    5.9zm15.204 15.536c-5.91 0-10.718-4.808-10.718-10.718s4.808-10.718 10.718-10.718 10.718 4.808 10.718
                    10.718-4.808 10.718-10.718 10.718z`}
            />
        </SvgIcon>
    )
}

CameraIcon.defaultProps = defaultProps
export { CameraIcon }
